export default function SubTitleBlog({ children }: { children: React.ReactNode }) {
    return (
      <h2 className='cz-post__subtitle'>{children}</h2>
    );
  }
